import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface BreadcrumbEntityTitle {
  path: string;
  id: string;
  title: string;
}

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbTitleService {

  private readonly subject =
    new BehaviorSubject<BreadcrumbEntityTitle | null>(null);

  readonly title$ = this.subject.asObservable();

  get current(): BreadcrumbEntityTitle | null {
    return this.subject.value;
  }

  setTitle(value: BreadcrumbEntityTitle): void {
    this.subject.next(value);
  }

  clear(): void {
    this.subject.next(null);
  }
}